import { Trans, useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { Text, TextButton } from '@wix/design-system';
import { EmptyStateBanner } from '../EmptyStateBanner';
import { useCallback, useEffect } from 'react';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import { useShallowRouter } from '@components/Hooks/useRouter';
import { updateQueryParams } from '@utils/route';
import { EmptyStateBannerProps } from '../EmptyStateBanner/EmptyStateBanner';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';

export const NoSearchResultsBanner = (
  props: Omit<EmptyStateBannerProps, 'title' | 'children'>,
) => {
  const { t } = useTranslation();
  const {
    state: { filters },
    templateSearchFieldRef,
  } = useTemplatesContext();
  const searchTerm = filters?.search;
  const { navigate, router } = useShallowRouter();
  const { logBiPageView } = useTemplatesBi({});

  const onClickTryDifferentSearch = useCallback(() => {
    templateSearchFieldRef?.current?.focus();
  }, [templateSearchFieldRef?.current]);

  const onClickBrowseTemplatesGallery = useCallback(() => {
    navigate(
      updateQueryParams({}, router, {
        all: true,
      }),
    );
  }, []);

  const titleText = t(
    'marketplace.templates-page.empty-state.search-no-matches-title',
    { searchTerm },
  );

  useEffect(() => {
    logBiPageView({ message_text: titleText });
  }, []);

  return (
    <EmptyStateBanner title={titleText} {...props}>
      <Trans i18nKey="marketplace.templates-page.empty-state.search-no-matches-subtitle">
        <Text size="medium" weight="thin" secondary>
          0 <TextButton onClick={onClickTryDifferentSearch}>1</TextButton>
          <TextButton onClick={onClickBrowseTemplatesGallery}>2</TextButton>
        </Text>
      </Trans>
    </EmptyStateBanner>
  );
};
